(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({
            behavior: 'instant'
          });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-sidebar-accordion"] && !Shopify.designMode) return;
  try {
    

(function () {
  'use strict';

  function openPolicy(layout, policyId) {

    if (!layout || !policyId) return;

    /* -----------------------------------------
       FIND THE REQUESTED POLICY
    ----------------------------------------- */

    const navItem = layout.querySelector(
      '.policy-nav-item[data-policy="' + CSS.escape(policyId) + '"]'
    );

    const selectedPanel = layout.querySelector(
      '.policy-panel[data-panel="' + CSS.escape(policyId) + '"]'
    );

    /* -----------------------------------------
       IF POLICY DOES NOT EXIST
       FALL BACK TO FIRST POLICY
    ----------------------------------------- */

    if (!navItem || !selectedPanel) {

      const firstNav = layout.querySelector('.policy-nav-item');
      const firstPanel = layout.querySelector('.policy-panel');

      if (!firstNav || !firstPanel) return;

      policyId = firstNav.dataset.policy;

      layout
        .querySelectorAll('.policy-nav-item')
        .forEach(function (item) {
          item.classList.remove('is-active');
        });

      firstNav.classList.add('is-active');

      layout
        .querySelectorAll('.policy-panel')
        .forEach(function (panel) {
          panel.classList.remove('is-active');
        });

      firstPanel.classList.add('is-active');

      openFirstAccordion(firstPanel);

      return;
    }

    /* -----------------------------------------
       LEFT NAV ACTIVE STATE
    ----------------------------------------- */

    layout
      .querySelectorAll('.policy-nav-item')
      .forEach(function (item) {
        item.classList.remove('is-active');
      });

    navItem.classList.add('is-active');


    /* -----------------------------------------
       SHOW SELECTED POLICY
    ----------------------------------------- */

    layout
      .querySelectorAll('.policy-panel')
      .forEach(function (panel) {
        panel.classList.remove('is-active');
      });

    selectedPanel.classList.add('is-active');


    /* -----------------------------------------
       OPEN FIRST ACCORDION
    ----------------------------------------- */

    openFirstAccordion(selectedPanel);
  }


  function openFirstAccordion(panel) {

    const accordions = panel.querySelectorAll('.policy-accordion');

    accordions.forEach(function (accordion, index) {
      accordion.open = index === 0;
    });
  }


  /* =========================================
     LEFT SIDEBAR CLICK
  ========================================= */

  document.addEventListener('click', function (event) {

    const navItem = event.target.closest('.policy-nav-item');

    if (!navItem) return;

    const layout = navItem.closest('.policy-layout');

    if (!layout) return;

    const policyId = navItem.dataset.policy;

    openPolicy(layout, policyId);

    /*
     * Optional:
     * Update URL without reloading page
     */

    const url = new URL(window.location.href);

    url.searchParams.set('policy', policyId);

    window.history.replaceState({}, '', url.toString());
  });


  /* =========================================
     ONLY ONE ACCORDION OPEN AT A TIME
  ========================================= */

  document.addEventListener('toggle', function (event) {

    if (!event.target.matches('.policy-accordion')) {
      return;
    }

    if (!event.target.open) {
      return;
    }

    const panel = event.target.closest('.policy-panel');

    if (!panel) return;

    panel
      .querySelectorAll('.policy-accordion')
      .forEach(function (accordion) {

        if (accordion !== event.target) {
          accordion.open = false;
        }

      });

  }, true);


  /* =========================================
     OPEN POLICY FROM URL
     
     Example:
     /pages/terms-policies?policy=policy_NDQPdp
  ========================================= */

  function initPolicyFromURL() {

    const layouts = document.querySelectorAll('.policy-layout');

    if (!layouts.length) return;

    const params = new URLSearchParams(window.location.search);

    const policyId = params.get('policy');

    layouts.forEach(function (layout) {

      if (policyId) {

        openPolicy(layout, policyId);

      } else {

        /*
         * No policy in URL.
         * Keep first policy active.
         */

        const activeNav = layout.querySelector(
          '.policy-nav-item.is-active'
        );

        const activePanel = layout.querySelector(
          '.policy-panel.is-active'
        );

        if (activePanel) {
          openFirstAccordion(activePanel);
        }

      }

    });
  }


  /* =========================================
     INITIALIZE
  ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initPolicyFromURL
    );

  } else {

    initPolicyFromURL();

  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collection"] && !Shopify.designMode) return;
  try {
    

function initTabbedCollection(section) {

  const buttons = section.querySelectorAll('.tab-button');
  const contents = section.querySelectorAll('.tab-content');

  if (!buttons.length) return;

  buttons.forEach(function(button){

    button.addEventListener('click', function(){

      const target = this.dataset.tab;

      // Remove active class
      buttons.forEach(function(btn){
        btn.classList.remove('active');
      });

      contents.forEach(function(content){
        content.classList.remove('active');
      });

      // Add active class
      this.classList.add('active');

      const activeTab = section.querySelector('#' + target);

      if(activeTab){
        activeTab.classList.add('active');
      }

    });

  });

}

document.addEventListener('DOMContentLoaded', function(){

  document.querySelectorAll('.tabbed-collection').forEach(function(section){

    initTabbedCollection(section);

  });

});

// Shopify Theme Editor
document.addEventListener('shopify:section:load', function(e){

  const section = e.target.querySelector('.tabbed-collection');

  if(section){
    initTabbedCollection(section);
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tab-btn').forEach(function(btn){

  btn.addEventListener('click',function(){

    document.querySelectorAll('.tab-btn').forEach(function(b){
      b.classList.remove('active');
    });

    document.querySelectorAll('.tab-content').forEach(function(c){
      c.classList.remove('active');
    });

    this.classList.add('active');

    document.getElementById(this.dataset.tab).classList.add('active');

  });

});
document.addEventListener("DOMContentLoaded", function () {

  const firstTab = document.querySelector(".tab-btn");
  const firstContent = document.querySelector(".tab-content");

  if (firstTab) firstTab.classList.add("active");
  if (firstContent) firstContent.classList.add("active");

  document.querySelectorAll(".tab-btn").forEach(function(btn){

    btn.addEventListener("click", function(){

      document.querySelectorAll(".tab-btn").forEach(function(b){
        b.classList.remove("active");
      });

      document.querySelectorAll(".tab-content").forEach(function(c){
        c.classList.remove("active");
      });

      this.classList.add("active");

      document.getElementById(this.dataset.tab).classList.add("active");

    });

  });

});
function initTabSwiper(tab) {

  const slider = tab.querySelector('.tabSwiper');

  if (!slider) return;

  // Already initialized? Just update it.
  if (slider.swiper) {
    slider.swiper.update();
    slider.swiper.slideTo(0);
    return;
  }

  new Swiper(slider, {
    loop: true,
    speed: 700,
    slidesPerView: 4,
    spaceBetween: 20,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },

    navigation: {
      nextEl: tab.querySelector('.swiper-button-next'),
      prevEl: tab.querySelector('.swiper-button-prev')
    },

    breakpoints: {
      0: {
        slidesPerView: 1
      },
      576: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      }
    }
  });

}

document.addEventListener('DOMContentLoaded', function () {

  // Initialize first active tab
  const firstTab = document.querySelector('.tab-content.active');
  if (firstTab) {
    initTabSwiper(firstTab);
  }

  // Tab click
  document.querySelectorAll('.tab-btn').forEach(function(btn){

    btn.addEventListener('click', function(){

      const id = this.dataset.tab;

      document.querySelectorAll('.tab-btn').forEach(function(b){
        b.classList.remove('active');
      });

      document.querySelectorAll('.tab-content').forEach(function(tab){
        tab.classList.remove('active');
      });

      this.classList.add('active');

      const activeTab = document.getElementById(id);
      activeTab.classList.add('active');

      // Wait until visible, then initialize/update Swiper
      setTimeout(function(){
        initTabSwiper(activeTab);
      }, 100);

    });

  });

});

document.addEventListener('shopify:section:load', function(){
  const firstTab = document.querySelector('.tab-content.active');
  if (firstTab) {
    initTabSwiper(firstTab);
  }
});

  } catch(e) { console.error(e); }
})();
})();
